function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallerySmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,13.72549%,13.72549%)",
      fillOpacity: 1
    },
    d: "M 14.109375 1.890625 L 14.109375 14.109375 L 1.890625 14.109375 L 1.890625 1.890625 L 14.109375 1.890625 M 14.109375 0.140625 L 1.890625 0.140625 C 0.929688 0.140625 0.140625 0.929688 0.140625 1.890625 L 0.140625 14.109375 C 0.140625 15.070312 0.929688 15.859375 1.890625 15.859375 L 14.109375 15.859375 C 15.070312 15.859375 15.859375 15.070312 15.859375 14.109375 L 15.859375 1.890625 C 15.859375 0.929688 15.070312 0.140625 14.109375 0.140625 Z M 9.871094 7.878906 L 7.25 11.253906 L 5.378906 8.996094 L 2.761719 12.367188 L 13.238281 12.367188 Z M 9.871094 7.878906 "
  })));
}
export default SvgGallerySmall;